import React from "react";

const ImageTextSection = ({ type }) => {
	return (
		<>
			{type === "desktop" && (
				<>
					{" "}
					<section className="hidden lg:flex flex flex-col lg:flex-row max-w-screen-xl  mx-auto pt-6 pb-0 lg:pt-12 lg:pb-0 bg-white">
						{/* Image Section */}
						<div className="flex-shrink-0">
							<img
								loading="lazy"
								decoding="async"
								src="/assets/blog-details/image.svg"
								alt="Package Delivery"
								className="w-[413px] h-[588px] rounded-md object-cover"
							/>
						</div>

						{/* Content Section */}
						<div className="mt-8 lg:mt-10 w-full max-w-[1300px] h-auto  text-gray-800 space-y-5 bg-[#E9F2F4] pl-10 pr-10 pt-12">
							<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
								In the competitive world of e-commerce, success stories often
								begin with a combination of passion, perseverance, and the right
								tools. Meet Alex Bennett, an aspiring entrepreneur whose journey
								into online retailing took a significant leap forward with
								Retail Arbitrage (RA) Dropshipping software.
							</p>

							<h2 className="font-semibold">The Beginnings of a Journey</h2>
							<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
								Alex's entrepreneurial energy kindled during his college years
								when he noticed a growing demand for unique gadgets and tech
								accessories among his peers. Keen to capitalize on this trend,
								he started sourcing and listing products locally on eBay and
								Amazon. While initial sales were promising, Alex faced
								challenges such as inventory management and profit margins.
							</p>

							<h2 className="font-semibold">
								Discovering Retail Arbitrage Dropshipping
							</h2>
							<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
								Driven by a desire to scale his business without investing in
								physical inventory, Alex stumbled upon RA Dropshipping software.
								This powerful tool allowed him to automate the sourcing process
								from major retailers like Walmart, Best Buy, and Home Depot.
								Alex gained a competitive edge in the market by leveraging the
								software’s capabilities to sync product listings and manage
								orders seamlessly.
							</p>

							<h2 className="font-semibold">Leveraging Data-Driven Insights</h2>
							<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
								One of the standout features of RA software for Alex was its
								ability to provide real-time market data and analytics. With
								insights into consumer preferences and buying trends, Alex could
								make informed decisions about product selection and pricing
								strategies. This data-driven approach significantly improved his
								chances of listing high-demand products that resounded with his
								target audience.
							</p>

							<h2 className="font-semibold">
								Scaling Operations and Efficiency
							</h2>
							<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
								With RA Dropshipping software handling the backend logistics,
								Alex could focus on scaling his business operations and
								optimizing customer experiences. Automating inventory updates,
								order processing, and shipment tracking freed up valuable time,
								allowing him to explore new product categories and expand his
								online store's offerings.
							</p>
						</div>
					</section>
					<section className=" hidden lg:flex flex flex-col lg:flex-row max-w-screen-xl mx-auto  pb-6 lg:pt-0 lg:pb-12 bg-[#E9F2F4] mt-[-80px] items-stretch">
						<div className="flex-shrink-0 w-[413px] rounded-md  flex flex-col justify-between">
							<div>
								<h2 className="font-semibold">
									Scaling Operations and Efficiency
								</h2>
								<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
									With RA Dropshipping software handling the backend logistics,
									Alex could focus on scaling his business operations and
									optimizing customer experiences. Automating inventory updates,
									order processing, and shipment tracking freed up valuable
									time, allowing him to explore new product categories and
									expand his online store's offerings.
								</p>
							</div>
						</div>
					</section>
					<section className="hidden lg:flex flex flex-col lg:flex-row max-w-screen-xl mx-auto  pb-6 lg:pt-0 lg:pb-12 bg-[#E9F2F4]  items-stretch">
						<div className="flex-shrink-0 w-full rounded-md  flex flex-col justify-between">
							<div>
								<h2 className="font-semibold">
									Achieving Milestones and Looking Ahead
								</h2>
								<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
									Within a year of adopting RA Dropshipping software, Alex's
									e-commerce venture surpassed $100,000 in revenue. This
									milestone not only validated his business model but also
									fueled his ambition to further scale and diversify. With plans
									to explore international markets and introduce new product
									lines, Alex remains committed to leveraging RA software as a
									cornerstone of his growth strategy.
								</p>
							</div>
							<div>
								<h2 className="font-semibold">Conclusion</h2>
								<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
									Alex's journey exemplifies the transformative impact of Retail
									Arbitrage Dropshipping software in empowering entrepreneurs to
									build successful e-commerce businesses. Alex turned his
									entrepreneurial dreams into reality by embracing automation,
									harnessing data-driven insights, and integrating strategic
									marketing initiatives. For aspiring entrepreneurs looking to
									embark on their own e-commerce journey, RA Dropshipping
									software offers a powerful toolkit to streamline operations,
									scale efficiently, and achieve sustainable growth. Embrace
									innovation, leverage technology, and pave the way for your
									e-commerce success story with Retail Arbitrage Dropshipping
									software.
								</p>
							</div>
						</div>
					</section>
				</>
			)}

			{/* Mobile Version */}
			{type == "mobile" && (
				<section className="flex lg:hidden flex-col max-w-screen-md mx-auto p-4 bg-white space-y-6">
					{/* Image Section */}
					<div className="w-full">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/blog-details/image.svg"
							alt="Package Delivery"
							className="w-full h-auto rounded-md object-cover"
						/>
					</div>

					{/* Content Section */}
					<div className="text-gray-800 bg-[#E9F2F4] p-4 rounded-md space-y-4">
						<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
							In the competitive world of e-commerce, success stories often
							begin with a combination of passion, perseverance, and the right
							tools. Meet Alex Bennett, an aspiring entrepreneur whose journey
							into online retailing took a significant leap forward with Retail
							Arbitrage (RA) Dropshipping software.
						</p>

						<h2 className="font-semibold">The Beginnings of a Journey</h2>
						<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
							Alex's entrepreneurial energy kindled during his college years
							when he noticed a growing demand for unique gadgets and tech
							accessories among his peers. Keen to capitalize on this trend, he
							started sourcing and listing products locally on eBay and Amazon.
							While initial sales were promising, Alex faced challenges such as
							inventory management and profit margins.
						</p>

						<h2 className="font-semibold">
							Discovering Retail Arbitrage Dropshipping
						</h2>
						<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
							Driven by a desire to scale his business without investing in
							physical inventory, Alex stumbled upon RA Dropshipping software.
							This powerful tool allowed him to automate the sourcing process
							from major retailers like Walmart, Best Buy, and Home Depot. Alex
							gained a competitive edge in the market by leveraging the
							software’s capabilities to sync product listings and manage orders
							seamlessly.
						</p>
						<h2 className="font-semibold">Leveraging Data-Driven Insights</h2>
						<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
							One of the standout features of RA software for Alex was its
							ability to provide real-time market data and analytics. With
							insights into consumer preferences and buying trends, Alex could
							make informed decisions about product selection and pricing
							strategies. This data-driven approach significantly improved his
							chances of listing high-demand products that resounded with his
							target audience.
						</p>

						<h2 className="font-semibold">Scaling Operations and Efficiency</h2>
						<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
							With RA Dropshipping software handling the backend logistics, Alex
							could focus on scaling his business operations and optimizing
							customer experiences. Automating inventory updates, order
							processing, and shipment tracking freed up valuable time, allowing
							him to explore new product categories and expand his online
							store's offerings.
						</p>
					</div>
					<div className="text-gray-800 bg-[#E9F2F4] p-4 rounded-md space-y-4">
						<h2 className="font-semibold">Scaling Operations and Efficiency</h2>
						<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
							With RA Dropshipping software handling the backend logistics, Alex
							could focus on scaling his business operations and optimizing
							customer experiences. Automating inventory updates, order
							processing, and shipment tracking freed up valuable time, allowing
							him to explore new product categories and expand his online
							store's offerings.
						</p>

						<h2 className="font-semibold">
							Achieving Milestones and Looking Ahead
						</h2>
						<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
							Within a year of adopting RA Dropshipping software, Alex's
							e-commerce venture surpassed $100,000 in revenue. This milestone
							not only validated his business model but also fueled his ambition
							to further scale and diversify. With plans to explore
							international markets and introduce new product lines, Alex
							remains committed to leveraging RA software as a cornerstone of
							his growth strategy.
						</p>
						<h2 className="font-semibold">Conclusion</h2>
						<p className="font-montserrat font-medium text-sm leading-tight tracking-normal">
							Alex's journey exemplifies the transformative impact of Retail
							Arbitrage Dropshipping software in empowering entrepreneurs to
							build successful e-commerce businesses. Alex turned his
							entrepreneurial dreams into reality by embracing automation,
							harnessing data-driven insights, and integrating strategic
							marketing initiatives. For aspiring entrepreneurs looking to
							embark on their own e-commerce journey, RA Dropshipping software
							offers a powerful toolkit to streamline operations, scale
							efficiently, and achieve sustainable growth. Embrace innovation,
							leverage technology, and pave the way for your e-commerce success
							story with Retail Arbitrage Dropshipping software.
						</p>
					</div>
				</section>
			)}
		</>
	);
};

export default ImageTextSection;
